import type { DraggableAttributes } from '@dnd-kit/core';
import type { useSortable } from '@dnd-kit/sortable';
import { Button, cn } from '@rematter/ui-web';
import { LucideGripVertical, LucideStar } from 'lucide-react';

import { hueToColor } from '~/modules/trade/_components/scale-ticket-pro/shared/HueColorPicker';

type EditCardOverlaysProps = {
  isFavorite: boolean;
  canEditColors: boolean;
  colorHue: number | null | undefined;
  onToggleFavorite: () => void;
  onColorSwatchPress: () => void;
  dragAttributes?: DraggableAttributes;
  dragListeners?: ReturnType<typeof useSortable>['listeners'];
};

export const EditCardOverlays = ({
  isFavorite,
  canEditColors,
  colorHue,
  onToggleFavorite,
  onColorSwatchPress,
  dragAttributes,
  dragListeners,
}: EditCardOverlaysProps) => (
  <>
    <Button
      variant="ghost"
      size="icon"
      icon={<LucideGripVertical size={14} />}
      className="!absolute !top-1 !left-1 !z-10 !h-6 !min-h-0 !w-6 !min-w-0 cursor-grab !border-none !p-0 opacity-40 hover:opacity-80"
      {...(dragAttributes ?? {})}
      {...(dragListeners ?? {})}
    />

    <Button
      variant="ghost"
      size="icon"
      icon={
        <LucideStar size={14} className={cn(isFavorite && 'fill-current')} />
      }
      className="!absolute !top-1 !right-1 !z-10 !h-6 !min-h-0 !w-6 !min-w-0 !border-none !p-0"
      onPress={onToggleFavorite}
    />

    {canEditColors && (
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          '!absolute !right-1.5 !bottom-1.5 !z-10 !h-5 !min-h-0 !w-5 !min-w-0 !rounded-full !p-0',
          colorHue == null
            ? '!border-2 !border-neutral/30 !bg-white'
            : '!border-2 !border-white/50',
        )}
        style={
          colorHue != null
            ? { backgroundColor: hueToColor(colorHue) ?? undefined }
            : undefined
        }
        onPress={onColorSwatchPress}
      />
    )}
  </>
);
